import React from 'react';
import { Layout, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AdoptionImportRoutes from '../../routes/distribution/AdoptionImportRoutes';

const { Sider } = Layout;

const AdoptionImportPage: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const pageItems = [
    {
      key: '/distribution/import/import',
      label: <Link to="/distribution/import/import">{t('receiver:adoptionImport.import')}</Link>,
    },
    {
      key: '/distribution/import/import-reports',
      label: (
        <Link to="/distribution/import/import-reports">
          {t('receiver:adoptionImport.importReports')}
        </Link>
      ),
    },
  ];

  return (
    <Layout className="layout">
      <Sider theme="light">
        <Menu mode="inline" selectedKeys={[location.pathname]} items={pageItems} />
      </Sider>
      <AdoptionImportRoutes />
    </Layout>
  );
};

export default AdoptionImportPage;
